// extracted by mini-css-extract-plugin
module.exports = {"work-time":"c6e8ba5398--work-time--SahPc"};